export default function ProgramStructure() {
  const steps = [
    { icon: 'ri-search-eye-line', title: 'Диагностика', desc: 'Анализируем текущие показатели отдела, определяем точки роста и проблемные зоны.' },
    { icon: 'ri-phone-line', title: 'Прослушивание звонков', desc: 'Слушаем реальные записи разговоров менеджеров, фиксируем типичные ошибки и удачные приёмы.' },
    { icon: 'ri-database-2-line', title: 'Анализ CRM', desc: 'Изучаем воронку, конверсию по этапам и качество работы с базой клиентов.' },
    { icon: 'ri-chat-1-line', title: 'Интервью', desc: 'Общаемся с руководителем и менеджерами, чтобы понять внутренние барьеры и ожидания.' },
    { icon: 'ri-settings-3-line', title: 'Подготовка программы', desc: 'Адаптируем программу под ваш продукт, рынок, цикл сделки и типичные сценарии.' },
    { icon: 'ri-presentation-line', title: 'Практический тренинг', desc: '80% времени — отработка на реальных кейсах: звонки, ролевые переговоры, разборы.' },
    { icon: 'ri-user-voice-line', title: 'Отработка звонков', desc: 'Каждый участник практикуется в безопасной среде с детальной обратной связью.' },
    { icon: 'ri-book-open-line', title: 'Домашние задания', desc: 'Между модулями менеджеры применяют навыки в работе и получают обратную связь.' },
    { icon: 'ri-file-list-3-line', title: 'Разбор реальных разговоров', desc: 'Анализируем новые звонки, корректируем стратегию, усиливаем успешные приёмы.' },
    { icon: 'ri-hand-heart-line', title: 'Сопровождение', desc: 'Поддержка после тренинга: разборы сложных кейсов, чат с тренером, корректировка.' },
  ];

  return (
    <section id="program" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6">
            Как построена программа обучения
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Системный подход от диагностики до сопровождения. Каждый этап приближает команду к стабильно высоким результатам холодных звонков.
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative">
            <div className="absolute left-6 top-0 bottom-0 w-0.5 bg-teal-200 hidden sm:block"></div>
            <div className="space-y-5">
              {steps.map((step, i) => (
                <div key={i} className="flex items-start gap-4 sm:gap-6">
                  <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0 z-10">
                    <span className="text-white font-bold text-sm">{i + 1}</span>
                  </div>
                  <div className="bg-white rounded-xl p-5 flex-1 shadow-sm border border-gray-100 flex items-start gap-4">
                    <div className="w-10 h-10 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className={`${step.icon} text-lg text-teal-600`}></i>
                    </div>
                    <div>
                      <h3 className="text-lg font-bold text-gray-900 mb-1">{step.title}</h3>
                      <p className="text-sm text-gray-600 leading-relaxed">{step.desc}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => {
              const el = document.getElementById('contact');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-teal-600 text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
          >
            Получить пример программы
            <i className="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}